<template>
  <v-row class="mb-5" justify="center" align="start">
    <v-col cols="6" v-if="productPending" class="mt-5 d-flex justify-center">
      <v-progress-circular
        :indeterminate="true"
        color="primary"
        size="32"
        width="4"
      />
    </v-col>

    <v-col cols="6" class="mt-5" v-if="!productPending">
      <v-card>
        <v-card-title>
          <div>
            <h3 class="text-h5 mb-2 word-break-all">{{ product.name }}</h3>
            <div class="word-break-all">{{ product.product_type_name }}</div>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="$router.push('/distributor/products/edit/' + product._jv.id)"
            >Edit Product</v-btn
          >
          <v-btn color="primary" @click="deleteDialogOpened = true"
            >Remove Product</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-col>

    <v-col cols="3" offset="1" class="mt-5" v-if="!productPending">
      <v-card>
        <v-card-title>
          <div>
            <h3 class="text-h5 mb-2">Image</h3>
          </div>
        </v-card-title>
        <div class="d-flex align-center justify-space-around fill-height">
          <v-img
            class="image-sample"
            :src="getImage(product.default_image_uuid)"
          />
        </div>
      </v-card>
    </v-col>

    <template>
      <v-dialog v-model="deleteDialogOpened" max-width="800">
        <v-card>
          <v-card-title class="text-h5 error text-white">
            Delete Product
          </v-card-title>

          <v-card-text>
            <div class="text-h6" style="line-height:1.4 !important">
              <p class="mt-2 mb-3">
                Do you really want to delete
                <strong>"{{ product.name || "" }}"?</strong>
              </p>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="py-3 px-3">
            <v-spacer></v-spacer>
            <v-btn variant="outlined" color="error" @click="deleteDialogOpened = false">
              Cancel
            </v-btn>
            <v-btn
              :loading="deleteDialogPending"
              :disabled="deleteDialogPending"
              color="error"
              @click="deleteProduct()"
            >
              Delete
              <template v-slot:loader>
                <span>Saving...</span>
              </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-row>
</template>

<script>
import helpers from "@/mixins/helpers";

export default {
  mixins: [helpers],

  data() {
    return {
      product: {},
      productPending: true,
      productVariants: [],

      productVariantHeaders: [
        { text: "SKU", sortable: false, value: "sku" },
        { text: "Description", sortable: false, value: "description" },
        { text: "Supplier", sortable: false, value: "supplier.name" },
        { text: "Actions", sortable: false, value: "", align: "center" },
      ],

      deleteDialogOpened: false,
      deleteDialogPending: false,
    };
  },

  mounted() {
    this.loadProduct();
  },

  methods: {
    endAction() {
      this.$router.push("/distributor/products");
    },

    async loadProduct() {
      this.productPending = true;

      try {
        this.product = await this.$store.dispatch("jv/get", [
          `products/${this.$route.params.id}`,
          {
            params: {
              include: "product_type,campaign_products",
            },
          },
        ]);
      } finally {
        this.productPending = false;
      }
    },

    async deleteProduct() {
      if (Object.values(this.product.campaign_products).length > 0) {
        this.$store.dispatch(
          "raiseError",
          "Cannot delete a product that is part of a store!"
        );
      } else {
        let resp = await this.$store.dispatch("jv/delete", this.product);

        this.$store.dispatch(
          "raiseSuccess",
          `Product ${this.product._jv.id} removed`
        );
        this.endAction();
      }
    },
  },
};
</script>
<style scoped>
.image-sample {
  width: 50px;
}
</style>

